import React, { useEffect, useState } from "react";
import Model from "../Model";
import tw from "tailwind-styled-components";
import * as Yup from "yup";
import Loading from "../Loading";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useFormik } from "formik";
import { InputGroup, Label, SubmitBtn } from "../Styles/InputStyles";
import Images from "../../Images";

const validationSchema = Yup.object().shape({
  clientId: Yup.number().required("Please enter client ID"),
  plan: Yup.string().required("Please select a plan"),
  amount: Yup.number().required("Please enter amount"),
  startDate: Yup.string().required("Please select start date"),
  nextBillingDue: Yup.string().required("Please select next billing date"),
});

const AddSubscription = ({
  isSubscriptionLoading,
  addSubscriptionMutate,
  apiData,
  setAddSubscription,
}) => {
  const initialValues = {
    clientId: "",
    plan: "",
    amount: "",
    startDate: "",
    nextBillingDue: "",
  };

  const [clientOptions, setClientOptions] = useState([]);

  useEffect(() => {
    if (apiData) {
      setClientOptions(
        apiData.map((client) => ({
          id: client.id,
          name: client.name,
        }))
      );
    }
  }, [apiData]);

  const formik = useFormik({
    initialValues,
    validationSchema,

    onSubmit: (values) => {
      const payload = {
        clientId: Number(values.clientId),
        plan: values.plan,
        amount: Number(values.amount),
        startDate: values.startDate,
        nextBillingDue: values.nextBillingDue,
      };

      console.log("Subscription payload:", payload);

      addSubscriptionMutate(payload);
    },
  });

  return (
    <Model
      width="w-11/12 max-w-lg"
      setOpenModel={setAddSubscription}
    >
      <FormWrapper>
        <Title>Add Subscription</Title>

        <form onSubmit={formik.handleSubmit}>
          <FormWrapper>

            <InputGroup>
              <Label htmlFor="clientId">Client ID</Label>
              <Input
                name="clientId"
                type=""
                placeholder="Enter client ID"
                value={formik.values.clientId}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  formik.setFieldValue("clientId", value);
                }}
                onBlur={formik.handleBlur}
              />
              {formik.touched.clientId && formik.errors.clientId && (
                <ErrorText>{formik.errors.clientId}</ErrorText>
              )}
            </InputGroup>

            <CombineInputGroup>
              <InputGroup>
                <Label htmlFor="plan">Plan</Label>
                <Select
                  className="w-full px-2"
                  name="plan"
                  value={formik.values.plan}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  displayEmpty
                >
                  <MenuItem value="" disabled>Select Plan</MenuItem>
                  <MenuItem value="1">Basic</MenuItem>
                  <MenuItem value="2">Standard</MenuItem>
                  <MenuItem value="3">Premium</MenuItem>
                </Select>
                {formik.touched.plan && formik.errors.plan && (
                  <ErrorText>{formik.errors.plan}</ErrorText>
                )}
              </InputGroup>

              <InputGroup>
                <Label htmlFor="amount">Amount</Label>
                <Input
                  name="amount"
                  type=""
                  placeholder="Enter amount"
                  value={formik.values.amount}
                  onChange={(e) => {
                    const value = e.target.value;

                    // Allow only numbers and one decimal point
                    if (/^\d*\.?\d*$/.test(value)) {
                      formik.setFieldValue("amount", value);
                    }
                  }}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.amount && formik.errors.amount && (
                  <ErrorText>{formik.errors.amount}</ErrorText>
                )}
              </InputGroup>

            </CombineInputGroup>

            <CombineInputGroup>
              <InputGroup>
                <Label htmlFor="startDate">
                  Start Date
                </Label>
                <FieldWrapper>
                  <img
                    src={Images.Calender}
                    alt="Calendar icon"
                    className="absolute w-4 left-2 top-3"
                  />
                  <Input
                    type="date"
                    name="startDate"
                    id="startDate"
                    className="pl-8"
                    value={formik.values.startDate}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </FieldWrapper>
                {formik.touched.startDate &&
                  formik.errors.startDate && (
                    <ErrorText>
                      {formik.errors.startDate}
                    </ErrorText>
                  )}
              </InputGroup>

              <InputGroup>
                <Label htmlFor="nextBillingDue">
                  Next Billing Due
                </Label>
                <FieldWrapper>
                  <img
                    src={Images.Calender}
                    alt="Calendar icon"
                    className="absolute w-4 left-2 top-3"
                  />
                  <Input
                    type="date"
                    name="nextBillingDue"
                    id="nextBillingDue"
                    className="pl-8"
                    value={formik.values.nextBillingDue}
                    min={formik.values.startDate}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </FieldWrapper>
                {formik.touched.nextBillingDue &&
                  formik.errors.nextBillingDue && (
                    <ErrorText>
                      {formik.errors.nextBillingDue}
                    </ErrorText>
                  )}
              </InputGroup>

            </CombineInputGroup>

          </FormWrapper>

          <BtnWrapper>
            <SubmitBtn
              type="submit"
              disabled={isSubscriptionLoading}
            >
              {isSubscriptionLoading ? (
                <Loading
                  height={16}
                  width={16}
                  noPadding={true}
                />
              ) : (
                "Add Subscription"
              )}
            </SubmitBtn>
          </BtnWrapper>
        </form>
      </FormWrapper>
    </Model>
  );
};

// const Label = tw.label`block text-sm font-medium text-gray-700 mb-1`;
const Input = tw.input`truncate border border-gray-300 border-m rounded pl-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200`;
const Button = tw.button`w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary-color hover:bg-hover-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50`;
const ErrorText = tw.div`text-red-500 text-sm`;
const Title = tw.h2`text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-center`;
const CombineInputGroup = tw.div`flex space-x-7`;
const FormWrapper = tw.div`px-1  space-y-3 `;
const BtnWrapper = tw.div`w-full flex items-center justify-center space-x-10 mt-8`;
const FieldWrapper = tw.div`w-full relative`;

export default AddSubscription;
